import { NgModule } from "@angular/core";
import { LorenAllAssetResolver } from "../loren-assets/resolvers/loren-asset-all.resolver";
import { LorenNotificationsResolver } from "../../shared/resolvers/loren-notifications.resolver.ts/loren-notifications.resolver";
import { LorenHomeRoutingModule } from "./loren-home-routing.module";
import { LorenHomeComponent } from "./components/loren-home/loren-home.component";
import { LorenHomeAlarmsTableComponent } from "./components/loren-home-alarms-table/loren-home-alarms-table.component";
import {LorenParameterCardComponent} from "../../shared/modules/loren-parameter-card/loren-parameter-card.component";

@NgModule({
  declarations: [],
  exports: [],
  providers: [LorenAllAssetResolver, LorenNotificationsResolver],
  imports: [
    LorenParameterCardComponent,
    LorenHomeRoutingModule,

    LorenHomeComponent,
    LorenHomeAlarmsTableComponent,
  ],
})
export class LorenHomeModule {}
